import React, { useState, useEffect } from "react";
import FiltersContainer from "./FiltersContainer";
import { Filters } from "../types";

const FiltersPopup = ({
  filterSelections,
  updateFilters,
  resetFilter,
  closePopup,
  updateImageFilter
}: {
  filterSelections: Filters;
  updateFilters: (filters: Filters) => void;
  resetFilter: () => void;
  closePopup: () => void;
  updateImageFilter: (imageUrl: string, clearSelfie: boolean) => void;
}) => {
  const [filters, setFilters] = useState(filterSelections);

  useEffect(() => {
    document.getElementsByTagName("body")[0].classList.add("modal-open");
    return () => {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
    };
  }, []);

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in ns-modal ns-modal-small"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header" style={{ paddingTop: 0 }}>
              <button type="button" className="close" onClick={closePopup}>
                <span aria-hidden="true">&times;</span>
              </button>
              {/* <h2 className="modal-title">Filters</h2> */}
            </div>
            <div className="modal-body" style={{ textAlign: "left" }}>
              <FiltersContainer
                filterSelections={filters}
                updateFilters={setFilters}
                resetFilter={resetFilter}
                updateImageFilter={updateImageFilter}
              />{" "}
              <div className="d-flex modal-inside-footer">
                <button
                  type="button"
                  className="btn btn-link"
                  data-dismiss="modal"
                  onClick={closePopup}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn secondary-btn"
                  onClick={() => {
                    updateFilters(filters);
                    closePopup();
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default FiltersPopup;
